var ReactIs,throwOnDirectAccess;module.exports=require("./factoryWithThrowingShims")();